<ng-container *ngIf="similarCourses$ | async as similarCourses">
    <section class="background-color-nearwhite">
        <div class="container">
            <div *ngIf="similarCourses.length > 3" class="headline">
                <h2 [innerHTML]="'similarCourses.coursesTitle' | translate"></h2>

                <div class="more" *ngIf="coursesFilteredMore$ | async as coursesFilteredMore">
                    <a (click)="showMoreLink()">({{ similarCourses.length }})</a>
                </div>
            </div>
            <ng-container *ngIf="similarCourses.length <= 3">
                <h2 [innerHTML]="'similarCourses.threeCoursesTitle' | translate" class="less-then-three"></h2>
                <p class="large" [innerHTML]="'similarCourses.threeCoursesText' | translate" class="less-then-three large"></p>
            </ng-container>
            <div class="wrapper">
                <ng-container *ngFor="let course of coursesFiltered; let i = index">
                    <da-course-card [course]="course"></da-course-card>
                </ng-container>
            </div>
            <section [ngClass]="{ hidden: (showMoreInformation$ | async) === false }">
                <div class="courses more-courses">
                    <ng-container *ngFor="let course of coursesFilteredMore$ | async">
                        <da-course-card *ngIf="course" [course]="course"></da-course-card>
                    </ng-container>
                </div>
            </section>
            <section *ngIf="coursesFilteredMore$ | async as coursesFilteredMore">
                <da-show-more
                    #showMoreSection
                    *ngIf="coursesFilteredMore.length > 0"
                    (toggle)="showMore($event)"
                    [labelMore]="'common.labelMore' | translate"
                    [labelLess]="'common.labelLess' | translate"
                    [backgroundColor]="'nearwhite'"
                ></da-show-more>
            </section>
        </div>
    </section>
</ng-container>
